import Model from '../../ModelBinding/Model';
import OutputFormatCollection from './OutputFormatCollection';
import MissionMediaOutputFormatAttributeCollection from '../MissionMediaOutputFormatAttribute/MissionMediaOutputFormatAttributeCollection';

export default class OutputFormat extends Model {
  public filename_pattern?: string;
  public offer_item_id?: string;
  public path_pattern?: string;
  public recipient?: string;
  public watermarked?: boolean;
  public attributes?: MissionMediaOutputFormatAttributeCollection;

  bind() {
    this.filename_pattern = this.getStringAttribute('filename_pattern');
    this.offer_item_id = this.getStringAttribute('offer_item_id');
    this.path_pattern = this.getStringAttribute('path_pattern');
    this.recipient = this.getStringAttribute('recipient');
    this.watermarked = this.getBooleanAttribute('watermarked');
    this.attributes = this.getRelationCollection(
      'attributes',
      MissionMediaOutputFormatAttributeCollection,
    ) as MissionMediaOutputFormatAttributeCollection;
  }

  static getCollection() {
    return OutputFormatCollection;
  }
}
